import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import styles from './outreach.module.scss';

// Message texts hold {factKey} placeholders that the engine fills in when sending;
// {ime} is the user's first name. Keys stay as stored, only the display is friendly.

const RE = /\{(\w+)\}/g;
const ME = { key: 'ime', label: 'ime korisnika', help: 'Ime korisnika.' };

/** What can be inserted: {ime} plus every number/string/enum fact. */
export const insertable = (catalog) => [
  ME,
  ...catalog.facts.filter((f) => !['list', 'boolean'].includes(f.type)),
];

export const placeholderKeys = (text) => [
  ...new Set([...(text || '').matchAll(RE)].map((m) => m[1])),
];

const describe = (catalog, key) => {
  if (key === 'ime') return ME;
  const f = catalog.facts.find(
    (x) => x.key === key && !['list', 'boolean'].includes(x.type)
  );
  return f || null;
};

export const PlaceholderChip = ({ catalog, code }) => {
  const info = describe(catalog, code);
  if (!info) {
    return (
      <Tooltip
        title={
          <>
            <code>{`{${code}}`}</code>
            <div>Nepoznat podatak – biće izostavljen iz poruke</div>
          </>
        }
      >
        <span className={`${styles.chip} ${styles.chipUnknown}`}>
          {`{${code}}`}
        </span>
      </Tooltip>
    );
  }
  return (
    <Tooltip
      title={
        <>
          <code>{`{${code}}`}</code>
          {info.help && <div>{info.help}</div>}
        </>
      }
    >
      <span className={styles.chip}>{info.label}</span>
    </Tooltip>
  );
};

PlaceholderChip.propTypes = {
  catalog: PropTypes.object.isRequired,
  code: PropTypes.string.isRequired,
};

/** Text with each placeholder rendered as a chip. */
export const TextWithChips = ({ catalog, text }) => {
  const parts = (text || '').split(/(\{\w+\})/g);
  return (
    <span className={styles.chipText}>
      {parts.map((p, i) => {
        const m = /^\{(\w+)\}$/.exec(p);
        return m ? (
          <PlaceholderChip key={i} catalog={catalog} code={m[1]} />
        ) : (
          <span key={i}>{p}</span>
        );
      })}
    </span>
  );
};

TextWithChips.propTypes = {
  catalog: PropTypes.object.isRequired,
  text: PropTypes.string,
};

/** "Podaci u tekstu:" row under a textarea; renders nothing without placeholders. */
export const ChipsRow = ({ catalog, text }) => {
  const keys = placeholderKeys(text);
  if (!keys.length) return null;
  return (
    <div className={styles.chipsRow}>
      <span className={styles.dim}>Podaci u tekstu:</span>
      {keys.map((k) => (
        <PlaceholderChip key={k} catalog={catalog} code={k} />
      ))}
    </div>
  );
};

ChipsRow.propTypes = {
  catalog: PropTypes.object.isRequired,
  text: PropTypes.string,
};
